<template>
   <div class="common-width common-items-center warp-btn" :style='{height:this.$store.state.blockNavHeight+"px"}'>
      <navBtn ref="navRef"></navBtn>
      <div class="slider">
         <div @click="leftFun">
            <svg t="1688958804046" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10599" width="36" height="36"><path d="M511.3 98.2c-228.8 0-414.9 186.1-414.9 414.9 0 23.9 2.6 48.2 6.5 71 0 0.1 0.2 0.1 0.3 0.2 1.7 5.8 6.8 10.1 13.1 10.1 7.6 0 13.8-6.2 13.8-13.8 0-0.5-0.2-0.9-0.3-1.3l0.2-0.1c-3.7-21.5-6-43.5-6-66C124 299.3 297.4 126 511.2 126s387.2 173.4 387.2 387.2-173.2 387.2-387.1 387.2c-142.9 0-267.4-77.6-334.5-192.8 0-0.1-0.1-0.1-0.1-0.2l-0.6-0.9c-2.3-4.3-6.8-7.4-12-7.4-7.6 0-13.8 6.2-13.8 13.8 0 3 1.2 5.6 2.8 7.9l-0.2 0.1C224.7 844.5 358.3 928 511.3 928c228.8 0 414.9-186.1 414.9-414.9S740.1 98.2 511.3 98.2z" fill="#3259CE" p-id="10600"></path><path d="M409 410.7l-82 83.6c-10.6 10.8-10.5 28.1 0.1 38.8l81.9 82.7 0.1-0.1c2.5 2.8 6.1 4.7 10.2 4.7 7.6 0 13.8-6.2 13.8-13.8 0-4-1.8-7.6-4.6-10.1l0.1-0.1-68.1-68.8h329.3c7.6 0 13.8-6.2 13.8-13.8s-6.2-13.8-13.8-13.8H360.2l68.4-69.8-0.1-0.1c2.8-2.5 4.6-6.1 4.6-10.1 0-7.6-6.2-13.8-13.8-13.8-4.2-0.3-7.8 1.6-10.3 4.5z" fill="#3259CE" p-id="10601"></path></svg>
         </div>
         <div @click="rightFun">
            <svg t="1688958746513" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9620" width="36" height="36"><path d="M512.3 98.2c-228.8 0-414.9 186.1-414.9 414.9 0 23.9 2.6 48.2 6.5 71 0 0.1 0.2 0.1 0.3 0.2 1.7 5.8 6.8 10.1 13.1 10.1 7.6 0 13.8-6.2 13.8-13.8 0-0.5-0.2-0.9-0.3-1.3l0.2-0.1c-3.7-21.5-6-43.5-6-66C125 299.3 298.4 126 512.2 126s387.2 173.4 387.2 387.2-173.3 387.2-387.1 387.2c-142.9 0-267.4-77.6-334.5-192.8 0-0.1-0.1-0.1-0.1-0.2l-0.6-0.9c-2.3-4.3-6.8-7.4-12-7.4-7.6 0-13.8 6.2-13.8 13.8 0 3 1.2 5.6 2.8 7.9l-0.2 0.1C225.6 844.5 359.3 928 512.3 928c228.8 0 414.9-186.1 414.9-414.9S741.1 98.2 512.3 98.2z" fill="#3259CE" p-id="9621"></path><path d="M614.7 410.7l82 83.6c10.6 10.8 10.5 28.1-0.1 38.8l-81.9 82.7-0.1-0.1c-2.5 2.8-6.1 4.7-10.2 4.7-7.6 0-13.8-6.2-13.8-13.8 0-4 1.8-7.6 4.6-10.1l-0.1-0.1 68.1-68.8H333.8c-7.6 0-13.8-6.2-13.8-13.8s6.2-13.8 13.8-13.8h329.5l-68.4-70 0.1-0.1c-2.8-2.5-4.6-6.1-4.6-10.1 0-7.6 6.2-13.8 13.8-13.8 4.3-0.1 7.9 1.8 10.5 4.7z" fill="#3259CE" p-id="9622"></path></svg>
         </div>
      </div>
   </div>
</template>
<script>
   import navBtn from './block-navBtn.vue'
   export default{
      components:{
          navBtn:navBtn
      },
      methods:{
         leftFun(){
            this.$refs.navRef.leftFun(90);
         },
         rightFun(){
            this.$refs.navRef.rightFun(90);
         }
      }
   }
</script>
<style lang="scss" scoped>
.slider{
   display: flex;
   cursor: pointer;
   position: relative;
   top: 3px;
}
</style>